function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.858 -0.000137329C108.564 1.08079 124.065 6.84085 137.779 17.3014C153.133 29.0142 163.751 44.1789 168.311 62.8979C174.9 89.9465 170.624 115.068 153.116 137.463C140.057 154.167 123.161 164.789 102.529 168.593C76.9419 173.31 53.543 167.666 32.8173 151.405C17.7874 139.612 8.58188 124.221 3.60516 106.102C-0.211167 92.2079 -0.170367 78.1057 3.44565 64.2348C7.55554 48.4693 15.1718 34.4688 27.2619 23.3034C40.2643 11.2953 55.3452 3.25396 73.1148 1.04899C78.8246 0.34049 84.6209 0.329801 90.858 -0.000137329ZM40.276 107.117C41.7508 108.434 43.2256 109.751 44.721 111.086C46.0942 110.286 47.2773 109.334 48.6284 108.858C53.0057 107.317 57.451 106.934 60.9875 110.569C64.1806 113.851 66.7173 118.236 63.8209 122.381C60.1915 127.575 63.0081 130.107 66.4093 133.032C67.4759 133.95 68.4769 134.943 69.0337 135.461C90.6808 113.815 112.056 92.4406 133.668 70.8299C132.568 69.8267 131.135 68.6675 129.882 67.3394C128.513 65.8894 127.31 64.2831 126.102 62.8254C117.308 69.5413 111.999 67.6082 108.401 63.5444C104.152 58.7442 103.32 55.5033 108.482 47.5486C105.837 44.656 103.308 41.8895 100.51 38.8292C79.8555 59.5309 59.1978 80.2829 38.4657 100.96C35.6711 103.748 37.5476 105.252 40.276 107.117Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1573 93.321C62.0994 92.1145 59.2998 90.642 56.5002 89.1695C56.5684 88.4186 56.6367 87.6676 56.7049 86.9166C58.5193 86.5018 61.7307 85.3994 61.9201 85.7843C63.1004 88.1825 69.3255 88.3817 65.1573 93.321Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.78 104.272C67.047 98.5769 67.047 98.5769 71.3651 94.4069C73.2541 96.9547 75.0878 99.4277 76.9214 101.901C75.6281 102.776 74.3348 103.651 72.78 104.272Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M81.2454 112.751C79.9848 111.442 78.9764 110.384 77.99 109.35C81.3281 104.633 81.3281 104.633 87.5929 111.209C84.4928 115.366 84.4928 115.366 81.2454 112.751Z",
  fill: "currentColor"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 171,
    viewBox: "0 0 172 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.358936f7.svg";
export { ForwardRef as ReactComponent };